import EzController from 'controllers/ez-base-controller';
import { ezResourceGrid } from 'ez-styles/assets/javascripts/ez-styles/justified-grid';
import { triggerCustomEvent } from 'lib/helpers'; // split-test: resource_show_modal_view
import { getAjaxModal } from 'lib/ajax-helpers'; // split-test: resource_show_modal_view
import events from 'lib/events'; // split-test: resource_show_modal_view

require('intersection-observer');

export default class ResourcesGridController extends EzController {
  connect() {
    this.initGrid();
    this.element.addEventListener('InitGrid', this.initGrid);
    window.addEventListener('InitAllGrids', this.initGrid);
  }

  disconnect() {
    this.element.removeEventListener('InitGrid', this.initGrid);
    window.removeEventListener('InitAllGrids', this.initGrid);
  }

  initGrid = () => {
    ezResourceGrid(this.element, {
      rowHeight: parseInt(this.element.getAttribute('data-row-height'), 10),
      maxRows: parseInt(this.element.getAttribute('data-max-rows'), 10),
      truncate: !!this.element.getAttribute('data-truncate-results'),
    });

    if (this.data.get('lazy') === 'true') {
      this.loadLazy(this.element.getAttribute('data-lazy-offset'));
    }
  }

  // start split-test: resource_show_modal_view
  // can remove check for split test and else path
  // if split test wins
  loadShowPage = (event) => {
    if (this.splitTestEnabled('show-page-modal-view')) {
      event.preventDefault();

      const resourceShowUrl = event.currentTarget.getAttribute('href');

      getAjaxModal(resourceShowUrl);

      triggerCustomEvent(events.show_page.modal.build_resource_navigation_context, {
        targetResourcePath: resourceShowUrl,
        targetResourceGroup: event.currentTarget.closest('[data-controller="resources-grid"]'),
      });
    }
  }
  // end split-test: resource_show_modal_view

  loadLazy(lazyLoadOffset) {
    const lazyImages = [].slice.call(this.element.querySelectorAll('.ez-resource-thumb__img'));

    if ('IntersectionObserver' in window) {
      const lazyImageObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const lazyImage = entry.target;
            lazyImage.src = lazyImage.dataset.lazySrc;
            lazyImage.srcset = lazyImage.dataset.lazySrcset;
            lazyImageObserver.unobserve(lazyImage);
          }
        });
      }, { rootMargin: `0px 0px ${lazyLoadOffset}px 0px` });

      lazyImages.forEach((lazyImage) => {
        lazyImageObserver.observe(lazyImage);
      });
    } else { // We should not get here as we use polyfill
      console.error('Intersection observer not supported'); // eslint-disable-line no-console
    }
  }
}
